import React from "react";
import SearchBox from "../../../../../components/common/searchBox/SearchBox";

import styles from "./Actions.scss";
import SortBy from "./SortBy";

class Actions extends React.Component {
  state = {
    searchVisible: false
  };

  toggleHideDeclined = () => {
    const { hideDeclined, onHideDeclined } = this.props;

    onHideDeclined(!hideDeclined);
  };

  render() {
    const { hideDeclined, sortedBy, onSearch, onSort } = this.props;
    const { searchVisible } = this.state;

    return (
      <React.Fragment>
        <section className={styles.actions}>
          <SortBy selected={sortedBy} onSelect={onSort} />

          <button
            className={styles.declinedVisibility}
            onClick={this.toggleHideDeclined}
          >
            {hideDeclined ? "Show Declined" : "Hide Declined"}
          </button>
        </section>

        {searchVisible && (
          <SearchBox positionClass={styles.searchArrow} onChange={onSearch} />
        )}
      </React.Fragment>
    );
  }
}

export default Actions;



// WEBPACK FOOTER //
// ./src/routes/employer/projectInformation/components/candidates/Actions.js